// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   AGCX User Feedback Page Styles
   File: user-feedback.css
   ========================================================================== */

.user-feedback-page {
    font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;
    background-color: #FFFFFF;
    color: #111827;
    padding: 40px 0 100px 0;
    position: relative;
    overflow: hidden;
}

.feedback-container {
    max-width: 1480px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 1;
}

.gold-text {
    color: #D3B06C;
}

/* ==========================================================================
   1. HERO SECTION
   ========================================================================== */
.feedback-hero {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 40px;
    margin-bottom: 60px;
}

.feedback-hero-left {
    flex: 1 1;
    max-width: 540px;
}

.feedback-hero-title {
    font-size: 65px;
    font-weight: 700;
    color: #111827;
    line-height: 1.15;
    margin: 0 0 18px 0;
}

.feedback-hero-desc {
    font-size: 19px;
    color: #6B7280;
    line-height: 1.6;
    margin: 0 0 32px 0;
}

.btn-feedback-form-pill {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 17px 32px;
    background-color: #D3B06C;
    color: #FFFFFF;
    font-size: 18px;
    font-weight: 600;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.25);
    transition: all 0.25s ease;
    text-decoration: none;
}

.btn-feedback-form-pill:hover {
    background-color: #C09D5B;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(211, 176, 108, 0.35);
}

.feedback-hero-right {
    width: 740px;
    max-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.feedback-hero-right img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
}


/* ==========================================================================
   2. SUBMIT FEEDBACK FORM CARD
   ========================================================================== */
.submit-feedback-card {
    background-color: #FFFFFF;
    border: 1px solid #F3F4F6;
    border-radius: 24px;
    padding: 36px 40px;
    box-shadow: 0 4px 25px rgb(0 0 0 / 7%);
    margin-bottom: 90px;

}

.submit-feedback-card h3 {
    font-size: 36px;
    font-weight: 600;
    color: #111827;
    margin: 0 0 30px 0;
}

.form-grid-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    margin-bottom: 20px;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.form-group label {
    font-size: 14px;
    font-weight: 600;
    color: #6A7282;
    margin-bottom: 3px;
}

.feedback-select,
.feedback-textarea {
    width: 100%;
    padding: 15px 16px;
    border: 1px solid #E5E7EB;
    border-radius: 15px;
    background-color: #fff;
    font-size: 14px;
    color: #111827;
    outline: none;
    transition: border-color 0.2s ease, background-color 0.2s ease;
    font-family: inherit;
}

.feedback-select:focus,
.feedback-textarea:focus {
    border-color: #D3B06C;
    background-color: #FFFFFF;
}

/* ==========================================================================
   CUSTOM SELECT DROPDOWN STYLES
   ========================================================================== */
.custom-select-container {
    position: relative;
    width: 100%;
    -webkit-user-select: none;
            user-select: none;
}

.custom-select-trigger {
    width: 100%;
    padding: 15px 18px;
    border: 1px solid #E5E7EB;
    border-radius: 15px;
    background-color: #FFFFFF;
    font-size: 14px;
    color: #9CA3AF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.custom-select-trigger.has-value {
    color: #111827;
    font-weight: 500;
}

.custom-select-trigger:hover {
    border-color: #D3B06C;
}

.custom-select-trigger.open {
    border-color: #D3B06C;
    box-shadow: 0 0 0 3px rgba(211, 176, 108, 0.15);
    background-color: #FFFFFF;
}

.custom-select-arrow {
    font-size: 18px;
    color: #6B7280;
    transition: transform 0.25s ease, color 0.2s ease;
}

.custom-select-trigger.open .custom-select-arrow {
    transform: rotate(180deg);
    color: #D3B06C;
}

.custom-select-options {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    right: 0;
    background-color: #FFFFFF;
    border: 1px solid #F0F0F0;
    border-radius: 16px;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
    z-index: 99;
    max-height: 250px;
    overflow-y: auto;
    padding: 6px;
    animation: dropdownFadeIn 0.2s ease-out forwards;
}

.custom-select-options::-webkit-scrollbar {
    width: 6px;
}

.custom-select-options::-webkit-scrollbar-track {
    background: #F9FAFB;
    border-radius: 10px;
}

.custom-select-options::-webkit-scrollbar-thumb {
    background: #D1D5DB;
    border-radius: 10px;
}

.custom-select-option {
    padding: 12px 16px;
    border-radius: 10px;
    font-size: 14px;
    color: #374151;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: all 0.15s ease;
    margin-bottom: 2px;
}

.custom-select-option:last-child {
    margin-bottom: 0;
}

.custom-select-option:hover {
    background-color: #FFFDF7;
    color: #D3B06C;
    font-weight: 600;
}

.custom-select-option.selected {
    background-color: #FEF3C7;
    color: #D3B06C;
    font-weight: 700;
}

.custom-select-option .check-icon {
    font-size: 16px;
    color: #D3B06C;
}

@keyframes dropdownFadeIn {
    from {
        opacity: 0;
        transform: translateY(-8px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.textarea-wrapper {
    position: relative;
}

.feedback-textarea {
    resize: vertical;
    min-height: 120px;
}

.char-count {
    position: absolute;
    bottom: 12px;
    right: 16px;
    font-size: 12px;
    color: #9CA3AF;
}

.form-actions-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
}

.btn-generate-attachment {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 10px 20px;
    background-color: #fff;
    color: #4B5563;
    font-size: 13px;
    font-weight: 600;
    border: 1px solid #E5E7EB;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;

}

.btn-generate-attachment:hover {
    background-color: #E5E7EB;
    color: #111827;
}

.btn-submit-feedback {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 15px 32px;
    background-color: #D1AA67;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 600;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.25);
    transition: all 0.25s ease;
}

.btn-submit-feedback:hover {
    background-color: #C09D5B;
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(211, 176, 108, 0.35);
}


/* ==========================================================================
   3. FEEDBACK REWARDS SECTION
   ========================================================================== */
.rewards-section {
    margin-bottom: 70px;
    background-color: #F9FAFB;
    padding: 70px 0px;

}

.section-titleh2 {
    font-size: 42px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 28px 0;
}

.rewards-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
}

.reward-card {
    background-color: #FFFFFF;
    border: 1px solid #F3F4F6;
    border-radius: 18px;
    padding: 26px;
    box-shadow: 0 1px 6px rgb(0 0 0 / 9%);
    transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.reward-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.06);
}

.reward-card-top {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
}

.reward-icon-badge {
    width: 44px;
    height: 44px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.reward-icon-badge img {
    width: 22px;
    height: 22px;
    object-fit: contain;
}

.reward-icon-badge.mint {
    background-color: #ECFDF5;
}

.reward-icon-badge.orange {
    background-color: #FFFBEB;
}

.reward-icon-badge.purple {
    background-color: #F5F3FF;
}

.reward-amount {
    font-size: 20px;
    font-weight: 800;
}

.reward-amount.mint-color {
    color: #10B981;
}

.reward-amount.orange-color {
    color: #D1AA67;
}

.reward-amount.purple-color {
    color: #8B5CF6;
}

.reward-card h4 {
    font-size: 16px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 8px 0;
}

.reward-card p {
    font-size: 14px;
    color: #6B7280;
    line-height: 1.55;
    margin: 0;
}


/* ==========================================================================
   4. HOW WE OPERATE SECTION
   ========================================================================== */
.operate-section {
    margin-bottom: 80px;
}

.section-title-center {
    font-size: 44px;
    font-weight: 600;
    color: #111827;
    text-align: center;
    margin: 0 0 36px 0;
}

.operate-grid-wrapper {
    display: flex;
    align-items: center;
    gap: 16px;
}

.operate-card {
    flex: 1 1;
    background-color: #FFFFFF;
    border: 1px solid #F1F5F9;
    border-radius: 20px;
    padding: 32px 20px;
    text-align: center;
    box-shadow: 0 1px 2px rgb(0 0 0 / 6%);
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: transform 0.25s ease;
}

.operate-card:hover {
    transform: translateY(-4px);
    border-color: #E2E8F0;
}

.operate-icon-box {
    width: 52px;
    height: 52px;
    border-radius: 16px;
    background-color: #FFFBEB;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.operate-icon-box img {
    width: 26px;
    height: 26px;
    object-fit: contain;
}

.operate-card h4 {
    font-size: 16px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 8px 0;
}

.operate-grid-wrapper i.ri-arrow-right-s-line {
    font-size: 36px;
}

.operate-card p {
    font-size: 13.5px;
    color: #6B7280;
    line-height: 1.5;
    margin: 0;
}

.operate-arrow {
    color: #D1D5DB;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}


/* ==========================================================================
   5. HIGH-QUALITY SUGGESTIONS & SIDEBAR
   ========================================================================== */
.suggestions-layout {
    display: grid;
    grid-template-columns: 1fr 340px;
    gap: 32px;
    align-items: start;
}

.suggestions-left-col {
    min-width: 0;
}

/* Category Filter Pills */
.category-pills-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    width: 100%;
    min-width: 0;
}

.category-pills {
    display: flex;
    align-items: center;
    gap: 10px;
    overflow-x: auto;
    scroll-behavior: smooth;
    white-space: nowrap;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding: 6px 2px;
    flex: 1 1;
    min-width: 0;
}

.category-pills::-webkit-scrollbar {
    display: none;
}

.pill-btn {
    padding: 8px 18px;
    border-radius: 50px;
    border: 1px solid #E5E7EB;
    background-color: #ECECEC;
    color: #4B5563;
    font-size: 13.5px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
    white-space: nowrap;
}

.pill-btn:hover {
    background-color: #F3F4F6;
    color: #111827;
}

.pill-btn.active {
    background-color: #D1AA67;
    color: #FFFFFF;
    border-color: #D3B06C;
}

.pills-scroll-btn {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #FFFFFF;
    border: 1px solid #E5E7EB;
    color: #374151;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    z-index: 5;
    flex-shrink: 0;
    transition: all 0.2s ease;
}

.pills-scroll-btn.left {
    margin-right: 8px;
}

.pills-scroll-btn.right {
    margin-left: 8px;
}

.pills-scroll-btn:hover {
    background-color: #D1AA67;
    color: #FFFFFF;
    border-color: #D1AA67;
}

/* Suggestion Item Card */
.suggestion-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.suggestion-card {
    background-color: #FFFFFF;
    border: 1px solid #F1F5F9;
    border-radius: 20px;
    padding: 24px;
    box-shadow: 0 0px 4px rgb(0 0 0 / 8%);
    transition: border-color 0.2s ease;
}

.suggestion-card:hover {
    border-color: #E2E8F0;
}

.suggestion-card-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
}

.user-avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    color: #FFFFFF;
    font-weight: 700;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.user-avatar.purple-bg {
    background-color: #6366F1;
}

.user-avatar.yellow-bg {
    background-color: #F59E0B;
}

.user-avatar.green-bg {
    background-color: #10B981;
}

.user-name {
    font-size: 16px;
    font-weight: 700;
    color: #111827;
}

.tag-badge {
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 13px;
    height: auto;
    width: auto;
    font-weight: 600;
    text-transform: capitalize;
}

.tag-badge.trading {
    background-color: #fef3c77d;
    color: #D1AA67;
}

.tag-badge.uiux {
    background-color: #FEF3C7;
    color: #D97706;
}

.tag-badge.analytics {
    background-color: #FEF3C7;
    color: #D97706;
}

.suggestion-title {
    font-size: 16px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 8px 0;
}

.suggestion-content {
    font-size: 13.5px;
    color: #6B7280;
    line-height: 1.6;
    margin: 0 0 16px 0;
}

.suggestion-footer {
    display: flex;
    align-items: center;
    gap: 20px;
    font-size: 13.5px;
    color: #9CA3AF;
}

span.action-item.active {
    color: #D1AA67;
}

.action-item {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    transition: color 0.2s ease;
}

.action-item:hover {
    color: #4B5563;
}


/* Sidebar CTA Card */
.sidebar-cta-card {
    background-color: #FFFFFF;
    border: 1px solid #F1F5F9;
    border-radius: 24px;
    padding: 32px 24px;
    text-align: center;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.sidebar-cta-img {
    width: 140px;
    height: auto;
    margin-bottom: 20px;
    object-fit: contain;
}

.sidebar-cta-card h3 {
    font-size: 18px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 10px 0;
}

.sidebar-cta-card p {
    font-size: 13px;
    color: #6B7280;
    line-height: 1.55;
    margin: 0 0 24px 0;
}

.btn-send-feedback-cta {
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 24px;
    background-color: #D3B06C;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 600;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.25);
    transition: all 0.25s ease;
    margin-bottom: 16px;
}

.btn-send-feedback-cta:hover {
    background-color: #C09D5B;
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(211, 176, 108, 0.35);
}

.response-time-note {
    font-size: 12px;
    color: #9CA3AF;
    margin: 0;
}

.response-time-note strong {
    color: #4B5563;
}


/* ==========================================================================
   RESPONSIVE ADJUSTMENTS
   ========================================================================== */

@media (max-width:1500px) {

    .feedback-container {
        max-width: 95%;
    }

    .feedback-hero-title {
        font-size: 54px;
    }

}


@media (max-width: 1200px) {

    .feedback-hero-right {
        width: 400px;
    }

    .feedback-hero-desc {
        font-size: 16px;
        margin: 0 0 24px 0;
    }

    .btn-feedback-form-pill {
        padding: 12px 28px;
        color: #FFFFFF;
        font-size: 15px;
    }

    .submit-feedback-card h3 {
        font-size: 30px;
    }

    .section-titleh2 {
        font-size: 30px;
    }

    .section-title-center {
        font-size: 30px;
    }

    .feedback-hero-title {
        font-size: 40px;
    }

    .rewards-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .operate-grid-wrapper {
        gap: 10px;
    }

    .operate-arrow {
        transform: rotate(90deg);
    }

    .suggestions-layout {
        grid-template-columns: 1fr;
    }
}

@media (max-width:991px) {

    .feedback-hero-title {
        font-size: 36px;
    }

    .section-titleh2 {
        font-size: 24px;
    }

    .rewards-section {
        margin-bottom: 40px;
        padding: 40px 0px;
    }

    .section-title-center {
        font-size: 24px;
    }

    .user-feedback-page {
        padding: 40px 0 40px;
    }

    .submit-feedback-card h3 {
        font-size: 24px;
    }

    .submit-feedback-card {

        border-radius: 18px;
        padding: 24px;
        margin-bottom: 50px;
    }

    .btn-submit-feedback {
        padding: 10px 24px;
        font-size: 13px;
    }

    .form-grid-row {
        grid-template-columns: 1fr;
    }

    .rewards-grid {
        grid-template-columns: 1fr;
    }
}


@media (max-width:767px) {

    .feedback-hero {
        flex-direction: column;
        text-align: center;
        gap: 30px;
        margin-bottom: 40px;
    }

    .section-titleh2 {
        font-size: 22px;
        margin-bottom: 15px;
    }

    .section-title-center {
        font-size: 22px;
        margin-bottom: 22px;
    }

    .operate-section {
        margin-bottom: 40px;
    }

    .operate-card {
        width: 100%;
        flex: 1 1;
    }

    .operate-grid-wrapper {
        gap: 8px;
        flex-direction: column;
    }

    .feedback-hero-title {
        font-size: 26px;
        margin-bottom: 10px;
    }

    .feedback-hero-desc {
        font-size: 14px;
        margin: 0 0 15px 0;
    }

    .btn-feedback-form-pill {
        padding: 8px 24px;
        font-size: 13px;
    }

    .feedback-hero-right {
        width: 280px;
    }

    .submit-feedback-card h3 {
        font-size: 20px;
    }

    .custom-select-trigger {
        padding: 9px 15px;
        border-radius: 10px;
        font-size: 13px;
    }

    .form-group label {
        font-size: 12px;
        margin-bottom: 0px;
    }

    .feedback-select,
    .feedback-textarea {
        padding: 10px 15px;
        border-radius: 10px;
        font-size: 13px;
    }

    .rewards-section {
        margin-bottom: 32px;
        padding: 30px 0px;
    }


}

@media (max-width:580px) {

    .form-actions-row {
        flex-direction: column;
        margin-top: 15px;
        gap: 12px;
    }

    .form-actions-row button {
        width: 100%;
        justify-content: center;
    }


}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/UserFeedback/user-feedback.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E;IACI,oEAAoE;IACpE,yBAAyB;IACzB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;;+EAE+E;AAC/E;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gDAAgD;IAChD,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;;AAGA;;+EAE+E;AAC/E;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;;AAEvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,aAAa;IACb,8DAA8D;IAC9D,oBAAoB;AACxB;;AAEA;;IAEI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;;+EAE+E;AAC/E;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,+CAA+C;IAC/C,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iDAAiD;AACrD;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,2CAA2C;IAC3C,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gDAAgD;AACpD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;;AAE7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gDAAgD;IAChD,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,gDAAgD;AACpD;;;AAGA;;+EAE+E;AAC/E;IACI,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;;AAErB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,qCAAqC;IACrC,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,SAAS;AACb;;;AAGA;;+EAE+E;AAC/E;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,qCAAqC;IACrC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;;AAGA;;+EAE+E;AAC/E;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;IAChB,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yCAAyC;IACzC,UAAU;IACV,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,qCAAqC;IACrC,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;;AAGA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gDAAgD;IAChD,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;;AAGA;;+EAE+E;;AAE/E;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;;AAGA;;IAEI;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,mBAAmB;QACnB,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;;AAGA;;IAEI;QACI,sBAAsB;QACtB,kBAAkB;QAClB,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,SAAO;IACX;;IAEA;QACI,QAAQ;QACR,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;;QAEI,kBAAkB;QAClB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;IACrB;;;AAGJ;;AAEA;;IAEI;QACI,sBAAsB;QACtB,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;;;AAGJ","sourcesContent":["/* ==========================================================================\n   AGCX User Feedback Page Styles\n   File: user-feedback.css\n   ========================================================================== */\n\n.user-feedback-page {\n    font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;\n    background-color: #FFFFFF;\n    color: #111827;\n    padding: 40px 0 100px 0;\n    position: relative;\n    overflow: hidden;\n}\n\n.feedback-container {\n    max-width: 1480px;\n    margin: 0 auto;\n    padding: 0 20px;\n    position: relative;\n    z-index: 1;\n}\n\n.gold-text {\n    color: #D3B06C;\n}\n\n/* ==========================================================================\n   1. HERO SECTION\n   ========================================================================== */\n.feedback-hero {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 40px;\n    margin-bottom: 60px;\n}\n\n.feedback-hero-left {\n    flex: 1;\n    max-width: 540px;\n}\n\n.feedback-hero-title {\n    font-size: 65px;\n    font-weight: 700;\n    color: #111827;\n    line-height: 1.15;\n    margin: 0 0 18px 0;\n}\n\n.feedback-hero-desc {\n    font-size: 19px;\n    color: #6B7280;\n    line-height: 1.6;\n    margin: 0 0 32px 0;\n}\n\n.btn-feedback-form-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 17px 32px;\n    background-color: #D3B06C;\n    color: #FFFFFF;\n    font-size: 18px;\n    font-weight: 600;\n    border: none;\n    border-radius: 50px;\n    cursor: pointer;\n    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.25);\n    transition: all 0.25s ease;\n    text-decoration: none;\n}\n\n.btn-feedback-form-pill:hover {\n    background-color: #C09D5B;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(211, 176, 108, 0.35);\n}\n\n.feedback-hero-right {\n    width: 740px;\n    max-width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.feedback-hero-right img {\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n}\n\n\n/* ==========================================================================\n   2. SUBMIT FEEDBACK FORM CARD\n   ========================================================================== */\n.submit-feedback-card {\n    background-color: #FFFFFF;\n    border: 1px solid #F3F4F6;\n    border-radius: 24px;\n    padding: 36px 40px;\n    box-shadow: 0 4px 25px rgb(0 0 0 / 7%);\n    margin-bottom: 90px;\n\n}\n\n.submit-feedback-card h3 {\n    font-size: 36px;\n    font-weight: 600;\n    color: #111827;\n    margin: 0 0 30px 0;\n}\n\n.form-grid-row {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px;\n    margin-bottom: 20px;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.form-group label {\n    font-size: 14px;\n    font-weight: 600;\n    color: #6A7282;\n    margin-bottom: 3px;\n}\n\n.feedback-select,\n.feedback-textarea {\n    width: 100%;\n    padding: 15px 16px;\n    border: 1px solid #E5E7EB;\n    border-radius: 15px;\n    background-color: #fff;\n    font-size: 14px;\n    color: #111827;\n    outline: none;\n    transition: border-color 0.2s ease, background-color 0.2s ease;\n    font-family: inherit;\n}\n\n.feedback-select:focus,\n.feedback-textarea:focus {\n    border-color: #D3B06C;\n    background-color: #FFFFFF;\n}\n\n/* ==========================================================================\n   CUSTOM SELECT DROPDOWN STYLES\n   ========================================================================== */\n.custom-select-container {\n    position: relative;\n    width: 100%;\n    user-select: none;\n}\n\n.custom-select-trigger {\n    width: 100%;\n    padding: 15px 18px;\n    border: 1px solid #E5E7EB;\n    border-radius: 15px;\n    background-color: #FFFFFF;\n    font-size: 14px;\n    color: #9CA3AF;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);\n}\n\n.custom-select-trigger.has-value {\n    color: #111827;\n    font-weight: 500;\n}\n\n.custom-select-trigger:hover {\n    border-color: #D3B06C;\n}\n\n.custom-select-trigger.open {\n    border-color: #D3B06C;\n    box-shadow: 0 0 0 3px rgba(211, 176, 108, 0.15);\n    background-color: #FFFFFF;\n}\n\n.custom-select-arrow {\n    font-size: 18px;\n    color: #6B7280;\n    transition: transform 0.25s ease, color 0.2s ease;\n}\n\n.custom-select-trigger.open .custom-select-arrow {\n    transform: rotate(180deg);\n    color: #D3B06C;\n}\n\n.custom-select-options {\n    position: absolute;\n    top: calc(100% + 8px);\n    left: 0;\n    right: 0;\n    background-color: #FFFFFF;\n    border: 1px solid #F0F0F0;\n    border-radius: 16px;\n    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);\n    z-index: 99;\n    max-height: 250px;\n    overflow-y: auto;\n    padding: 6px;\n    animation: dropdownFadeIn 0.2s ease-out forwards;\n}\n\n.custom-select-options::-webkit-scrollbar {\n    width: 6px;\n}\n\n.custom-select-options::-webkit-scrollbar-track {\n    background: #F9FAFB;\n    border-radius: 10px;\n}\n\n.custom-select-options::-webkit-scrollbar-thumb {\n    background: #D1D5DB;\n    border-radius: 10px;\n}\n\n.custom-select-option {\n    padding: 12px 16px;\n    border-radius: 10px;\n    font-size: 14px;\n    color: #374151;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    margin-bottom: 2px;\n}\n\n.custom-select-option:last-child {\n    margin-bottom: 0;\n}\n\n.custom-select-option:hover {\n    background-color: #FFFDF7;\n    color: #D3B06C;\n    font-weight: 600;\n}\n\n.custom-select-option.selected {\n    background-color: #FEF3C7;\n    color: #D3B06C;\n    font-weight: 700;\n}\n\n.custom-select-option .check-icon {\n    font-size: 16px;\n    color: #D3B06C;\n}\n\n@keyframes dropdownFadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-8px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.textarea-wrapper {\n    position: relative;\n}\n\n.feedback-textarea {\n    resize: vertical;\n    min-height: 120px;\n}\n\n.char-count {\n    position: absolute;\n    bottom: 12px;\n    right: 16px;\n    font-size: 12px;\n    color: #9CA3AF;\n}\n\n.form-actions-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 24px;\n}\n\n.btn-generate-attachment {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 10px 20px;\n    background-color: #fff;\n    color: #4B5563;\n    font-size: 13px;\n    font-weight: 600;\n    border: 1px solid #E5E7EB;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n}\n\n.btn-generate-attachment:hover {\n    background-color: #E5E7EB;\n    color: #111827;\n}\n\n.btn-submit-feedback {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 15px 32px;\n    background-color: #D1AA67;\n    color: #FFFFFF;\n    font-size: 15px;\n    font-weight: 600;\n    border: none;\n    border-radius: 50px;\n    cursor: pointer;\n    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.25);\n    transition: all 0.25s ease;\n}\n\n.btn-submit-feedback:hover {\n    background-color: #C09D5B;\n    transform: translateY(-1px);\n    box-shadow: 0 6px 18px rgba(211, 176, 108, 0.35);\n}\n\n\n/* ==========================================================================\n   3. FEEDBACK REWARDS SECTION\n   ========================================================================== */\n.rewards-section {\n    margin-bottom: 70px;\n    background-color: #F9FAFB;\n    padding: 70px 0px;\n\n}\n\n.section-titleh2 {\n    font-size: 42px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 28px 0;\n}\n\n.rewards-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 24px;\n}\n\n.reward-card {\n    background-color: #FFFFFF;\n    border: 1px solid #F3F4F6;\n    border-radius: 18px;\n    padding: 26px;\n    box-shadow: 0 1px 6px rgb(0 0 0 / 9%);\n    transition: transform 0.25s ease, box-shadow 0.25s ease;\n}\n\n.reward-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.06);\n}\n\n.reward-card-top {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 16px;\n}\n\n.reward-icon-badge {\n    width: 44px;\n    height: 44px;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.reward-icon-badge img {\n    width: 22px;\n    height: 22px;\n    object-fit: contain;\n}\n\n.reward-icon-badge.mint {\n    background-color: #ECFDF5;\n}\n\n.reward-icon-badge.orange {\n    background-color: #FFFBEB;\n}\n\n.reward-icon-badge.purple {\n    background-color: #F5F3FF;\n}\n\n.reward-amount {\n    font-size: 20px;\n    font-weight: 800;\n}\n\n.reward-amount.mint-color {\n    color: #10B981;\n}\n\n.reward-amount.orange-color {\n    color: #D1AA67;\n}\n\n.reward-amount.purple-color {\n    color: #8B5CF6;\n}\n\n.reward-card h4 {\n    font-size: 16px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 8px 0;\n}\n\n.reward-card p {\n    font-size: 14px;\n    color: #6B7280;\n    line-height: 1.55;\n    margin: 0;\n}\n\n\n/* ==========================================================================\n   4. HOW WE OPERATE SECTION\n   ========================================================================== */\n.operate-section {\n    margin-bottom: 80px;\n}\n\n.section-title-center {\n    font-size: 44px;\n    font-weight: 600;\n    color: #111827;\n    text-align: center;\n    margin: 0 0 36px 0;\n}\n\n.operate-grid-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.operate-card {\n    flex: 1;\n    background-color: #FFFFFF;\n    border: 1px solid #F1F5F9;\n    border-radius: 20px;\n    padding: 32px 20px;\n    text-align: center;\n    box-shadow: 0 1px 2px rgb(0 0 0 / 6%);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    transition: transform 0.25s ease;\n}\n\n.operate-card:hover {\n    transform: translateY(-4px);\n    border-color: #E2E8F0;\n}\n\n.operate-icon-box {\n    width: 52px;\n    height: 52px;\n    border-radius: 16px;\n    background-color: #FFFBEB;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n}\n\n.operate-icon-box img {\n    width: 26px;\n    height: 26px;\n    object-fit: contain;\n}\n\n.operate-card h4 {\n    font-size: 16px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 8px 0;\n}\n\n.operate-grid-wrapper i.ri-arrow-right-s-line {\n    font-size: 36px;\n}\n\n.operate-card p {\n    font-size: 13.5px;\n    color: #6B7280;\n    line-height: 1.5;\n    margin: 0;\n}\n\n.operate-arrow {\n    color: #D1D5DB;\n    font-size: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n\n/* ==========================================================================\n   5. HIGH-QUALITY SUGGESTIONS & SIDEBAR\n   ========================================================================== */\n.suggestions-layout {\n    display: grid;\n    grid-template-columns: 1fr 340px;\n    gap: 32px;\n    align-items: start;\n}\n\n.suggestions-left-col {\n    min-width: 0;\n}\n\n/* Category Filter Pills */\n.category-pills-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n    margin-bottom: 24px;\n    width: 100%;\n    min-width: 0;\n}\n\n.category-pills {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    overflow-x: auto;\n    scroll-behavior: smooth;\n    white-space: nowrap;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n    padding: 6px 2px;\n    flex: 1;\n    min-width: 0;\n}\n\n.category-pills::-webkit-scrollbar {\n    display: none;\n}\n\n.pill-btn {\n    padding: 8px 18px;\n    border-radius: 50px;\n    border: 1px solid #E5E7EB;\n    background-color: #ECECEC;\n    color: #4B5563;\n    font-size: 13.5px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    flex-shrink: 0;\n    white-space: nowrap;\n}\n\n.pill-btn:hover {\n    background-color: #F3F4F6;\n    color: #111827;\n}\n\n.pill-btn.active {\n    background-color: #D1AA67;\n    color: #FFFFFF;\n    border-color: #D3B06C;\n}\n\n.pills-scroll-btn {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background-color: #FFFFFF;\n    border: 1px solid #E5E7EB;\n    color: #374151;\n    font-size: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n    z-index: 5;\n    flex-shrink: 0;\n    transition: all 0.2s ease;\n}\n\n.pills-scroll-btn.left {\n    margin-right: 8px;\n}\n\n.pills-scroll-btn.right {\n    margin-left: 8px;\n}\n\n.pills-scroll-btn:hover {\n    background-color: #D1AA67;\n    color: #FFFFFF;\n    border-color: #D1AA67;\n}\n\n/* Suggestion Item Card */\n.suggestion-list {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.suggestion-card {\n    background-color: #FFFFFF;\n    border: 1px solid #F1F5F9;\n    border-radius: 20px;\n    padding: 24px;\n    box-shadow: 0 0px 4px rgb(0 0 0 / 8%);\n    transition: border-color 0.2s ease;\n}\n\n.suggestion-card:hover {\n    border-color: #E2E8F0;\n}\n\n.suggestion-card-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n.user-avatar {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    color: #FFFFFF;\n    font-weight: 700;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.user-avatar.purple-bg {\n    background-color: #6366F1;\n}\n\n.user-avatar.yellow-bg {\n    background-color: #F59E0B;\n}\n\n.user-avatar.green-bg {\n    background-color: #10B981;\n}\n\n.user-name {\n    font-size: 16px;\n    font-weight: 700;\n    color: #111827;\n}\n\n.tag-badge {\n    padding: 3px 10px;\n    border-radius: 12px;\n    font-size: 13px;\n    height: auto;\n    width: auto;\n    font-weight: 600;\n    text-transform: capitalize;\n}\n\n.tag-badge.trading {\n    background-color: #fef3c77d;\n    color: #D1AA67;\n}\n\n.tag-badge.uiux {\n    background-color: #FEF3C7;\n    color: #D97706;\n}\n\n.tag-badge.analytics {\n    background-color: #FEF3C7;\n    color: #D97706;\n}\n\n.suggestion-title {\n    font-size: 16px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 8px 0;\n}\n\n.suggestion-content {\n    font-size: 13.5px;\n    color: #6B7280;\n    line-height: 1.6;\n    margin: 0 0 16px 0;\n}\n\n.suggestion-footer {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    font-size: 13.5px;\n    color: #9CA3AF;\n}\n\nspan.action-item.active {\n    color: #D1AA67;\n}\n\n.action-item {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n    transition: color 0.2s ease;\n}\n\n.action-item:hover {\n    color: #4B5563;\n}\n\n\n/* Sidebar CTA Card */\n.sidebar-cta-card {\n    background-color: #FFFFFF;\n    border: 1px solid #F1F5F9;\n    border-radius: 24px;\n    padding: 32px 24px;\n    text-align: center;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.sidebar-cta-img {\n    width: 140px;\n    height: auto;\n    margin-bottom: 20px;\n    object-fit: contain;\n}\n\n.sidebar-cta-card h3 {\n    font-size: 18px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 10px 0;\n}\n\n.sidebar-cta-card p {\n    font-size: 13px;\n    color: #6B7280;\n    line-height: 1.55;\n    margin: 0 0 24px 0;\n}\n\n.btn-send-feedback-cta {\n    width: 100%;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 12px 24px;\n    background-color: #D3B06C;\n    color: #FFFFFF;\n    font-size: 14px;\n    font-weight: 600;\n    border: none;\n    border-radius: 50px;\n    cursor: pointer;\n    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.25);\n    transition: all 0.25s ease;\n    margin-bottom: 16px;\n}\n\n.btn-send-feedback-cta:hover {\n    background-color: #C09D5B;\n    transform: translateY(-1px);\n    box-shadow: 0 6px 18px rgba(211, 176, 108, 0.35);\n}\n\n.response-time-note {\n    font-size: 12px;\n    color: #9CA3AF;\n    margin: 0;\n}\n\n.response-time-note strong {\n    color: #4B5563;\n}\n\n\n/* ==========================================================================\n   RESPONSIVE ADJUSTMENTS\n   ========================================================================== */\n\n@media (max-width:1500px) {\n\n    .feedback-container {\n        max-width: 95%;\n    }\n\n    .feedback-hero-title {\n        font-size: 54px;\n    }\n\n}\n\n\n@media (max-width: 1200px) {\n\n    .feedback-hero-right {\n        width: 400px;\n    }\n\n    .feedback-hero-desc {\n        font-size: 16px;\n        margin: 0 0 24px 0;\n    }\n\n    .btn-feedback-form-pill {\n        padding: 12px 28px;\n        color: #FFFFFF;\n        font-size: 15px;\n    }\n\n    .submit-feedback-card h3 {\n        font-size: 30px;\n    }\n\n    .section-titleh2 {\n        font-size: 30px;\n    }\n\n    .section-title-center {\n        font-size: 30px;\n    }\n\n    .feedback-hero-title {\n        font-size: 40px;\n    }\n\n    .rewards-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .operate-grid-wrapper {\n        gap: 10px;\n    }\n\n    .operate-arrow {\n        transform: rotate(90deg);\n    }\n\n    .suggestions-layout {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width:991px) {\n\n    .feedback-hero-title {\n        font-size: 36px;\n    }\n\n    .section-titleh2 {\n        font-size: 24px;\n    }\n\n    .rewards-section {\n        margin-bottom: 40px;\n        padding: 40px 0px;\n    }\n\n    .section-title-center {\n        font-size: 24px;\n    }\n\n    .user-feedback-page {\n        padding: 40px 0 40px;\n    }\n\n    .submit-feedback-card h3 {\n        font-size: 24px;\n    }\n\n    .submit-feedback-card {\n\n        border-radius: 18px;\n        padding: 24px;\n        margin-bottom: 50px;\n    }\n\n    .btn-submit-feedback {\n        padding: 10px 24px;\n        font-size: 13px;\n    }\n\n    .form-grid-row {\n        grid-template-columns: 1fr;\n    }\n\n    .rewards-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n\n@media (max-width:767px) {\n\n    .feedback-hero {\n        flex-direction: column;\n        text-align: center;\n        gap: 30px;\n        margin-bottom: 40px;\n    }\n\n    .section-titleh2 {\n        font-size: 22px;\n        margin-bottom: 15px;\n    }\n\n    .section-title-center {\n        font-size: 22px;\n        margin-bottom: 22px;\n    }\n\n    .operate-section {\n        margin-bottom: 40px;\n    }\n\n    .operate-card {\n        width: 100%;\n        flex: 1;\n    }\n\n    .operate-grid-wrapper {\n        gap: 8px;\n        flex-direction: column;\n    }\n\n    .feedback-hero-title {\n        font-size: 26px;\n        margin-bottom: 10px;\n    }\n\n    .feedback-hero-desc {\n        font-size: 14px;\n        margin: 0 0 15px 0;\n    }\n\n    .btn-feedback-form-pill {\n        padding: 8px 24px;\n        font-size: 13px;\n    }\n\n    .feedback-hero-right {\n        width: 280px;\n    }\n\n    .submit-feedback-card h3 {\n        font-size: 20px;\n    }\n\n    .custom-select-trigger {\n        padding: 9px 15px;\n        border-radius: 10px;\n        font-size: 13px;\n    }\n\n    .form-group label {\n        font-size: 12px;\n        margin-bottom: 0px;\n    }\n\n    .feedback-select,\n    .feedback-textarea {\n        padding: 10px 15px;\n        border-radius: 10px;\n        font-size: 13px;\n    }\n\n    .rewards-section {\n        margin-bottom: 32px;\n        padding: 30px 0px;\n    }\n\n\n}\n\n@media (max-width:580px) {\n\n    .form-actions-row {\n        flex-direction: column;\n        margin-top: 15px;\n        gap: 12px;\n    }\n\n    .form-actions-row button {\n        width: 100%;\n        justify-content: center;\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
